import React, { useState, useEffect } from "react";
import { Container } from "./styles";
import { DataAccess } from "./DataAccess";
import { Loading } from "../Loading/Loading";
import { StudentSearch } from "../common/StudentSearch";
import { getAccessData } from "../../api/autenticoAPI";
import { Box } from "@mui/material";

export const SearchRegister = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [dataInfo, setDataInfo] = useState([]);

  // Quando um aluno é selecionado no componente de busca
  const handleStudentSelect = (student) => {
    setSelectedStudent(student);
    setError(null);
    setDataInfo([]);
  };

  // Efeito para buscar dados de acesso quando um aluno é selecionado
  useEffect(() => {
    if (selectedStudent) {
      setLoading(true);

      // Tenta usar NumeroMatricula primeiro (padrão legado/Autentico), 
      // se não existir, usa AlunoID (fallback)
      const registration = selectedStudent.NumeroMatricula
        ? String(selectedStudent.NumeroMatricula)
        : String(selectedStudent.AlunoID);

      console.log("Buscando dados de acesso para:", selectedStudent.Nome, "Reg:", registration);

      getAccessData(registration)
        .then((res) => {
          console.log("Dados recebidos:", res);
          setDataInfo(res);
        })
        .catch((error) => {
          console.error("Erro na busca de dados de acesso:", error);
          setError("Erro ao buscar dados de acesso do estudante. Verifique se o aluno possui cadastro no app.");
          setDataInfo([]);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedStudent]);

  return (
    <Container>
      <Box sx={{ width: "100%", maxWidth: "800px", margin: "20px auto" }}>
        <StudentSearch
          onSelect={handleStudentSelect}
          label="Digite o nome do aluno para consulta (mín. 3 caracteres)"
        />
      </Box>

      {error && (
        <div style={{ color: "red", textAlign: "center", margin: "20px" }}>
          {error}
        </div>
      )}

      {dataInfo.length > 0 && <DataAccess users={dataInfo} />}

      {loading && <Loading />}
    </Container>
  );
};
